/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool


import React, { useEffect, useState, lazy } from 'react';
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Home from './pages/Home';
import Shops from './pages/Shops';
import SellerPackages from './components/customerDashboard/SellerPackages';
import Cart from './pages/Cart';
import EventDetails from './pages/EventDetails';
import Details from './pages/Details';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import CategoryShop from './pages/CategoryShop';
import MainIngredientShop  from './pages/MainIngredientShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import CustomerDashboard from './pages/CustomerDashboard';
import ProtectUser from './utils/ProtectUser';
import Index from './components/customerDashboard/Index';
import Orders from './components/customerDashboard/Orders';
import DepositsAndBalances from './components/customerDashboard/DepositsAndBalances';
import EventDetailsCustomerDashboard from './components/customerDashboard/EventDetailsCustomerDashboard';
import FloorPlanner from './components/customerDashboard/FloorPlannerGridSize';
import SampleMenus from './components/customerDashboard/SampleMenusImages';
import MyCustomMenu from './components/customerDashboard/MyCustomMenu';
import ChangePassword from './components/customerDashboard/ChangePassword';
import Wishlist from './components/customerDashboard/Wishlist';
import MyProfile from './components/customerDashboard/MyProfile';
import MyGallery from './components/customerDashboard/MyGallery';
import OrderDetails from './components/customerDashboard/OrderDetails';
import Chat from './components/customerDashboard/Chat';
import CustomerTestimonialsDashboard from './components/customerDashboard/CustomerTestimonialsDashboard';
import ConfirmOrder from './pages/ConfirmOrder';
import AboutUs from './pages/AboutUs';
import GalleryImages from './pages/GalleryImages';

import { get_category, get_mainIngredient, get_galleryImages } from './store/reducers/homeReducer';
import { get_seller_by_frontEndURL } from './store/reducers/sellerReducer';

import config from './config';

function App() {
  const sellerFrontEndURL = config.STR_FRONTEND_URL;
  const { seller } = useSelector(state => state.seller);
  const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
  const sellerShopName = seller?.shopName;
  const sellerShopNameSlug = seller?.shopNameSlug;
    
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(get_category(sellerFrontEndURL));
    dispatch(get_mainIngredient(sellerFrontEndURL));
    dispatch(get_seller_by_frontEndURL(sellerFrontEndURL));
    dispatch(get_galleryImages(sellerFrontEndURL));
  }, []);

  const getIconBaseName = (shopName) =>
    shopName.replace(/ /g, '_').replace(/'/g, '').toLowerCase();

  // Favicon + document title
  useEffect(() => {
    const baseName = sellerShopName && sellerShopName !== ''
      ? getIconBaseName(sellerShopName)
      : 'favicon';

    document.title = sellerShopName || 'Kosher Caterer';

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = `/${baseName}_favicon.ico?v=${Date.now()}`;
  }, [sellerShopName]);

  // Dynamic manifest (Android homescreen)
  useEffect(() => {
    if (!sellerShopName) return;

    const baseName = getIconBaseName(sellerShopName);

    fetch(`/${baseName}_icon_192.png`)
      .then(res => res.blob())
      .then(blob => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      }))
      .then(base64Icon => {
        const manifest = {
          short_name: sellerShopName,
          name: sellerShopName,
          icons: [
            {
              src: base64Icon,
              sizes: "192x192",
              type: "image/png"
            },
            {
              src: `/${baseName}_icon_512.png`,
              sizes: "512x512",
              type: "image/png"
            }
          ],
          //start_url: `/${sellerShopNameSlug}`,
          start_url: sellerShopNameSlug ? `/${sellerShopNameSlug}` : '/',
          display: "standalone",
          theme_color: sellerPrimaryColor1 || "#ffffff",
          background_color: "#ffffff"
        };

        const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
        const manifestUrl = URL.createObjectURL(blob);

        let manifestLink = document.querySelector("link[rel='manifest']");
        if (!manifestLink) {
          manifestLink = document.createElement('link');
          manifestLink.rel = 'manifest';
          document.head.appendChild(manifestLink);
        }
        manifestLink.href = manifestUrl;
      });
  }, [sellerShopName, sellerPrimaryColor1, sellerShopNameSlug]);

  // iOS homescreen (Safari ignores manifest.json)
  useEffect(() => {
    if (!sellerShopName) return;

    const baseName = getIconBaseName(sellerShopName);

    let metaTitle = document.querySelector("meta[name='mobile-web-app-title']");
    if (!metaTitle) {
      metaTitle = document.createElement('meta');
      metaTitle.name = 'mobile-web-app-title';
      document.head.appendChild(metaTitle);
    }
    metaTitle.content = sellerShopName;

    let metaCapable = document.querySelector("meta[name='apple-mobile-web-app-capable']");
    if (!metaCapable) {
      metaCapable = document.createElement('meta');
      metaCapable.name = 'mobile-web-app-capable';
      document.head.appendChild(metaCapable);
    }
    metaCapable.content = 'yes';

    let appleIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (!appleIcon) {
      appleIcon = document.createElement('link');
      appleIcon.rel = 'apple-touch-icon';
      document.head.appendChild(appleIcon);
    }
    appleIcon.href = `/${baseName}_icon_180.png`;
  }, [sellerShopName]);
  
  // Theme color
  useEffect(() => {
    let metaThemeColor = document.querySelector("meta[name='theme-color']");
    if (!metaThemeColor) {
      metaThemeColor = document.createElement('meta');
      metaThemeColor.name = 'theme-color';
      document.head.appendChild(metaThemeColor);
    }
    if (sellerPrimaryColor1) {
      metaThemeColor.setAttribute('content', sellerPrimaryColor1);
    }
  }, [sellerPrimaryColor1]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/login' element={<Login/>} />
        <Route path='/forgotPassword' element={<ForgotPassword/>} />
        <Route path='/resetPassword/:customerId' element={<ResetPassword/>} />
        <Route path='/register' element={<Register/>} />
        <Route path='/shops' element={<Shops/>} />
        <Route path='/shops/:holidayURLParam' element={<Shops/>} />
        <Route path='/galleryImages' element={<GalleryImages/>} />
        <Route path='/aboutUs' element={<AboutUs/>} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/eventDetails' element={<EventDetails />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/productsCategory?' element={<CategoryShop />} />
        <Route path='/productsMainIngredient?' element={<MainIngredientShop />} />
        <Route path='/products/search?' element={<SearchProducts />} />
        <Route path='/product/details/:slug' element={<Details/>} /> 
        <Route path='/order/confirm?' element={<ConfirmOrder/>} /> 
        
        <Route path='/customerDashboard' element={<ProtectUser />}>
          <Route path='' element={<CustomerDashboard/>}>
            <Route path='' element={<Index/>} />
            <Route path='myProfile' element={<MyProfile/>} />
            <Route path='myOrders' element={<Orders/>} />
            <Route path='depositsAndBalances' element={<DepositsAndBalances/>} />
            <Route path='eventDetailsCustomerDashboard' element={<EventDetailsCustomerDashboard/>} /> 
            <Route path='FloorPlanner' element={<FloorPlanner/>} /> 
            <Route path='sampleMenus' element={<SampleMenus/>} />
            <Route path='myCustomMenu' element={<MyCustomMenu/>} />
            <Route path='sellerPackages' element={<SellerPackages/>} />
            <Route path='changePassword' element={<ChangePassword/>} />
            <Route path='myWishlist' element={<Wishlist/>} /> 
            <Route path='myGallery' element={<MyGallery />} />
            <Route path='myCustomMenu' element={<MyCustomMenu/>} />
            <Route path='order/details/:orderId' element={<OrderDetails/>} /> 
            <Route path='chat' element={<Chat/>} /> 
            <Route path='chat/:chatTopic' element={<Chat/>} />
            <Route path='customerTestimonialsDashboard' element={<CustomerTestimonialsDashboard/>} />
          </Route>
        </Route>
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;


//my original code
// import React, { useEffect, useState, lazy } from 'react';
// import { BrowserRouter, Route, Routes} from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import './App.css';
// import Home from './pages/Home';
// import Shops from './pages/Shops';
// import SellerPackages from './components/customerDashboard/SellerPackages';
// import Cart from './pages/Cart';
// import EventDetails from './pages/EventDetails';
// import Details from './pages/Details';
// import Login from './pages/Login';
// import ForgotPassword from './pages/ForgotPassword';
// import ResetPassword from './pages/ResetPassword';
// import Register from './pages/Register';
// import CategoryShop from './pages/CategoryShop';
// import MainIngredientShop  from './pages/MainIngredientShop';
// import SearchProducts from './pages/SearchProducts';
// import Payment from './pages/Payment';
// import CustomerDashboard from './pages/CustomerDashboard';
// import ProtectUser from './utils/ProtectUser';
// import Index from './components/customerDashboard/Index';
// import Orders from './components/customerDashboard/Orders';
// import GiveDeposit from './components/customerDashboard/GiveDeposit';
// import EventDetailsCustomerDashboard from './components/customerDashboard/EventDetailsCustomerDashboard';
// import FloorPlanner from './components/customerDashboard/FloorPlannerGridSize';
// import SampleMenus from './components/customerDashboard/SampleMenusImages'; //'./pages/SampleMenus2';
// import MyCustomMenu from './components/customerDashboard/MyCustomMenu';
// import ChangePassword from './components/customerDashboard/ChangePassword';
// import Wishlist from './components/customerDashboard/Wishlist';
// import MyProfile from './components/customerDashboard/MyProfile';
// import OrderDetails from './components/customerDashboard/OrderDetails';
// import Chat from './components/customerDashboard/Chat';
// import CustomerTestimonialsDashboard from './components/customerDashboard/CustomerTestimonialsDashboard';
// import ConfirmOrder from './pages/ConfirmOrder';
// import AboutUs from './pages/AboutUs';
// import GalleryImages from './pages/GalleryImages';

// import { get_category, get_mainIngredient, get_galleryImages } from './store/reducers/homeReducer';
// import { get_seller_by_frontEndURL } from './store/reducers/sellerReducer';

// import config from './config';

// function App() {
//   //claude prompt how do set my own  icon for the browser bar for the frontend of a react project?

//   const sellerFrontEndURL = config.STR_FRONTEND_URL
//   //console.log('sellerFrontEndURL in app.jsx\n', sellerFrontEndURL)
//   const { seller } = useSelector(state => state.seller)
//   const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//   const sellerShopName = seller?.shopName
//   const sellerShopNameSlug = seller?.shopNameSlug
    
//   const dispatch = useDispatch()

//   useEffect(() => {
//     dispatch(get_category(sellerFrontEndURL))
//     dispatch(get_mainIngredient(sellerFrontEndURL))
//     dispatch(get_seller_by_frontEndURL(sellerFrontEndURL))
//     dispatch(get_galleryImages(sellerFrontEndURL))
//   },[])
  
//   // //console.log(seller)
//   // // i am trying to set the favicon based on the seller's shop name, 
//   // // it works locally and but not online
//   // // this code is app.jsx

//   // from claude
//   // i would like to add my react app icon to the home screen of my mobile device
//   // when i add to home screen it gets added with the docment title
//   // i would also like the icon to be the favicon icon which is not working

//   // Helper to build icon base path (shared across effects)
//   const getIconBaseName = (shopName) =>
//     shopName.replace(/ /g, '_').replace(/'/g, '').toLowerCase();

//   // ✅ Favicon + document title
//   useEffect(() => {
//     const baseName = sellerShopName && sellerShopName !== ''
//       ? getIconBaseName(sellerShopName)
//       : 'favicon';

//     document.title = sellerShopName || 'Kosher Caterer';

//     let link = document.querySelector("link[rel~='icon']");
//     if (!link) {
//       link = document.createElement('link');
//       link.rel = 'icon';
//       document.head.appendChild(link);
//     }
//     // Keep using .ico for browser tab favicon — that's fine
//     link.href = `/${baseName}_favicon.ico?v=${Date.now()}`;

//   }, [sellerShopName]);


//   // ✅ Dynamic manifest (Android homescreen)
//   // comment out manifest.json in public/index.html when using this dynamic manifest approach
//   useEffect(() => {
//     if (!sellerShopName) return;

//     const baseName = getIconBaseName(sellerShopName);

//     // Fetch the PNG and convert to base64 so the icon is embedded
//     // directly in the manifest — no separate network request needed
//     fetch(`/${baseName}_icon_192.png`)
//       .then(res => res.blob())
//       .then(blob => new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onloadend = () => resolve(reader.result); // base64 data URL
//         reader.readAsDataURL(blob);
//       }))
//       .then(base64Icon => {
//         const manifest = {
//           short_name: sellerShopName,
//           name: sellerShopName,
//           icons: [
//             {
//               src: base64Icon,           // ✅ embedded — no external fetch needed
//               sizes: "192x192",
//               type: "image/png"
//             },
//             {
//               // Keep the real URL as fallback
//               src: `/${baseName}_icon_512.png`,
//               sizes: "512x512",
//               type: "image/png"
//             }
//           ],
//           start_url: `/${sellerShopNameSlug}`,
//           display: "standalone",
//           theme_color: sellerPrimaryColor1 || "#ffffff",
//           background_color: "#ffffff"
//         };

//         const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
//         const manifestUrl = URL.createObjectURL(blob);

//         let manifestLink = document.querySelector("link[rel='manifest']");
//         if (!manifestLink) {
//           manifestLink = document.createElement('link');
//           manifestLink.rel = 'manifest';
//           document.head.appendChild(manifestLink);
//         }
//         manifestLink.href = manifestUrl;
//       });

//   }, [sellerShopName, sellerPrimaryColor1, sellerShopNameSlug]);

//   // ✅ iOS homescreen (Safari ignores manifest.json)
//   useEffect(() => {
//     if (!sellerShopName) return;

//     const baseName = getIconBaseName(sellerShopName);

//     //let metaTitle = document.querySelector("meta[name='apple-mobile-web-app-title']");
//   let metaTitle = document.querySelector("meta[name='mobile-web-app-title']");

//     if (!metaTitle) {
//       metaTitle = document.createElement('meta');
//       //metaTitle.name = 'apple-mobile-web-app-title';
//       metaTitle.name = 'mobile-web-app-title';
//       document.head.appendChild(metaTitle);
//     }
//     metaTitle.content = sellerShopName;
//     //<meta name="mobile-web-app-capable" content="yes">Understand this warning


//     let metaCapable = document.querySelector("meta[name='apple-mobile-web-app-capable']");
//     if (!metaCapable) {
//       metaCapable = document.createElement('meta');
//       //metaCapable.name = 'apple-mobile-web-app-capable';
//       metaCapable.name = 'mobile-web-app-capable';
//       document.head.appendChild(metaCapable);
//     }
//     metaCapable.content = 'yes';

//     let appleIcon = document.querySelector("link[rel='apple-touch-icon']");
//     if (!appleIcon) {
//       appleIcon = document.createElement('link');
//       appleIcon.rel = 'apple-touch-icon';
//       document.head.appendChild(appleIcon);
//     }
//     // ✅ PNG required — iOS will NOT use .ico as a touch icon
//     appleIcon.href = `/${baseName}_icon_180.png`;

//   }, [sellerShopName]);
  
//   // ✅ Theme color
//   useEffect(() => {
//     let metaThemeColor = document.querySelector("meta[name='theme-color']");
//     if (!metaThemeColor) {
//       metaThemeColor = document.createElement('meta');
//       metaThemeColor.name = 'theme-color';
//       document.head.appendChild(metaThemeColor);
//     }
//     if (sellerPrimaryColor1) {
//       metaThemeColor.setAttribute('content', sellerPrimaryColor1);
//     }
//   }, [sellerPrimaryColor1]);

//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path='/' element={<Home/>} />
//         <Route path='/login' element={<Login/>} />
//         <Route path='/forgotPassword' element={<ForgotPassword/>} />
//         <Route path='/resetPassword/:customerId' element={<ResetPassword/>} />
//         <Route path='/register' element={<Register/>} />
//         <Route path='/shops' element={<Shops/>} />
//         <Route path='/shops/:holidayURLParam' element={<Shops/>} />
//         <Route path='/galleryImages' element={<GalleryImages/>} />
//         <Route path='/aboutUs' element={<AboutUs/>} />
//         <Route path='/cart' element={<Cart />} />
//         <Route path='/eventDetails' element={<EventDetails />} />
//         <Route path='/payment' element={<Payment />} />
//         <Route path='/productsCategory?' element={<CategoryShop />} />
//         <Route path='/productsMainIngredient?' element={<MainIngredientShop />} />
//         <Route path='/products/search?' element={<SearchProducts />} />
//         <Route path='/product/details/:slug' element={<Details/>} /> 
//         <Route path='/order/confirm?' element={<ConfirmOrder/>} /> 
        
//         <Route path='/customerDashboard' element={<ProtectUser />}>
//           <Route path='' element={<CustomerDashboard/>}>
//             <Route path='' element={<Index/>} />
//             <Route path='myProfile' element={<MyProfile/>} />
//             <Route path='myOrders' element={<Orders/>} />
//             <Route path='giveDeposit' element={<GiveDeposit/>} />
//             <Route path='eventDetailsCustomerDashboard' element={<EventDetailsCustomerDashboard/>} /> 
//             <Route path='FloorPlanner' element={<FloorPlanner/>} /> 
//             <Route path='sampleMenus' element={<SampleMenus/>} />
//             <Route path='myCustomMenu' element={<MyCustomMenu/>} />
//             <Route path='sellerPackages' element={<SellerPackages/>} />
//             <Route path='changePassword' element={<ChangePassword/>} />
//             <Route path='myWishlist' element={<Wishlist/>} /> 
//             <Route path='myCustomMenu' element={<MyCustomMenu/>} />
//             <Route path='order/details/:orderId' element={<OrderDetails/>} /> 
//             <Route path='chat' element={<Chat/>} /> 
//             <Route path='chat/:chatTopic' element={<Chat/>} />
//             <Route path='customerTestimonialsDashboard' element={<CustomerTestimonialsDashboard/>} />
//           </Route>
//         </Route>
        
//       </Routes>
//     </BrowserRouter>
//   );
// }
// //<Route path='chat/:sellerId' element={<Chat/>} />           
// export default App;







